import { GanttChart } from "lucide-react";

import { SuperAdminOnly } from "@/components/shared/miscellaneous/superadmin-only";
import { Toggle } from "@/components/ui/toggle";

interface Props {
  showActivity: boolean;
  setShowActivity: (show: boolean) => void;
}

export const ActivityModeToggle = ({
  showActivity,
  setShowActivity,
}: Props) => {
  return (
    <SuperAdminOnly>
      <Toggle onClick={() => setShowActivity(!showActivity)}>
        <GanttChart className="w-4" />
      </Toggle>
    </SuperAdminOnly>
  );
};
